export class CenterAlertContact {

    private contactInternalId: string;
    private contactMail: string;
    private contactName: string;
    private contactPhone: string;

    constructor(contactInternalId?: string, contactMail?: string, contactName?: string, contactPhone?: string) {

        this.contactInternalId = contactInternalId;
        this.contactMail = contactMail;
        this.contactName = contactName;
        this.contactPhone = contactPhone;
    }

    public get ContactInternalId() {
        return this.contactInternalId;
    }
    public get ContactMail() {
        return this.contactMail;
    }
    public get ContactName() {
        return this.contactName;
    }
    public get ContactPhone() {
        return this.contactPhone;
    }
    public set ContactInternalId(contactInternalId) {
        this.contactInternalId = contactInternalId;
    }
    public set ContactMail(contactMail) {
        this.contactMail = contactMail;
    }
    public set ContactName(contactName) {
        this.contactName = contactName;
    }
    public set ContactPhone(contactPhone) {
        this.contactPhone = contactPhone;
    }
}
